import { gql } from '@apollo/client';

export const GENERATE_DASHBOARD_TABLE_EXPORT = gql`
    mutation GenerateDashboardTableExport($input: DashboardTableExportInput!) {
        generateDashboardTableExport(input: $input)
    }
`;

export interface DashboardTableSnapshotExportRowInput {
    metric: string;
    value: string;
}

export interface DashboardTableExportInput {
    fileNamePrefix: string;
    timezone?: string | null;
    snapshotSheetName?: string;
    mainSheetName?: string;
    snapshotRows?: DashboardTableSnapshotExportRowInput[] | null;
    mainColumnHeaders: string[];
    mainRows: string[][];
    auditSummary?: string | null;
    warehouseId?: number | null;
}

export interface GenerateDashboardTableExportResponse {
    generateDashboardTableExport: string;
}

export interface GenerateDashboardTableExportVariables {
    input: DashboardTableExportInput;
}
